<template>
  <q-page class="row" style="padding-top: 0px; padding-left: 0px;">
    <q-page-container class="col" style="padding-top: 0px; padding-left: 0px;">
      <router-view />
    </q-page-container>
  </q-page>
</template>

<script>
export default {
  name: 'PageAccount'
}
</script>
